// Visual style themes. Each theme has a landing background (image or video),
// three HOST backgrounds (lobby / game / reveal) and three PLAYER backgrounds
// (join / game / reveal). Only "hip_retro" is fully available today; the other
// three are placeholders (available:false) until their artwork is uploaded.

const HOST_IMG = "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/itaa2221_hostscreen.png";
const PLAYER_IMG = "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/5hefy8cc_PLAYERSCREEN2.png";
const RETRO_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/wcqgy2pk_HIP%20RETRO%20FIRST%20SCREEN.mp4";
// Hip & Retro — NEW start-screen clip (host landing / player first screen).
const RETRO_COMP_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/1d1ci3xc_HIPPY3.mp4";
// Hip & Retro — screen 2 + linked screens (player join-room / host lobby / get-ready).
const RETRO_SCREEN2_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/584buhiv_AAHIP2.mp4";
// Hip & Retro — 3rd background: in-game / play screen (host "now playing" + player answer/buzz).
const RETRO_SCREEN3_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/ktha4ebc_Comp%201_3.mp4";
const RETRO_LANDING_IMG = "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/cg5eiza2_BEGIN%20SCHERM.png";
// Shared lobby/join clip — used on BOTH the host lobby (HostSetup) and the
// player Join Room screen so they look identical.
export const LOBBY_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/j8l87k0s_HIP%20RETRO%20PLAYER%20SCREEN%20JOIN%20ROOM.mp4";
// Shared in-game clip — host "record spinning" screen + player answer/buzz screen.
export const PLAY_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/6hq0fueg_HIPRETRO%20PLAYER%20PLAY%20SCREEN.mp4";
// Score/result clip — host in-game (music playing) screen + player result/reveal screen.
const SCORE_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/cckecctn_HIPRETRO%20SCORE%20SCREEN.mp4";
// Rock & Roll — first-screen (landing + player join gate) clip.
const ROCK_GOTHIC_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/86kik9x5_ROCK%20GOTHIC.mp4";
// Rock & Roll — second screen: host lobby + player join room clip.
const ROCK_LOBBY_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/5jbhsw24_ROCKGOTHIC%20BOY%20GIRL.mp4";
// Rock & Roll — in-game clip: host "now playing" screen + player answer/buzz screen.
const ROCK_OLDWOMAN_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/u7hmsdgm_ROCKGOTHIC%20OLD%20WOMAN.mp4";
// Rock & Roll — host afspeel (in_round) + resultaat (reveal) background clip.
const ROCK_HOST_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/9g9q4aiu_ROCK%20GOTHIC.mp4";
// Rock & Roll — host "game over" / eindscherm background clip.
const ROCK_HOST_GAMEOVER_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/pmrzrj5u_ROCKGOTHIC%20OLD%20WOMAN.mp4";
// Bling & Flava — host game-config screen + matching player join/lobby clip.
const BLING_FLAVA_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/0hbbcwqi_BLING%20FLAVA%201.mp4";
// Bling & Flava — "get ready" / waiting-to-start screen (host lobby + player waiting).
const BLING_FLAVA2_VIDEO = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/d6821so7_BLINGFLAVA2.mp4";
// Bling & Flava — start (landing) screen + in-game/reveal clip for host and player.
const BLING_FLAVA3_VIDEO = "https://customer-assets-wrfwihn1.emergentagent.net/job_08d49250-382a-4cb1-91a3-6efa45406f9b/artifacts/28cv86r5_BLINGFLAVA%20VIDEO2.mp4";

export const THEMES = [
  {
    id: "hip_retro",
    name: "Hip & Retro",
    icon: "Disc3",
    accent: "#e8564f",
    available: true,
    landing: { type: "video", url: RETRO_COMP_VIDEO, poster: RETRO_LANDING_IMG },
    joinVideo: RETRO_SCREEN2_VIDEO,
    lobbyVideo: RETRO_SCREEN2_VIDEO,
    playVideo: RETRO_SCREEN3_VIDEO,
    revealVideo: SCORE_VIDEO,
    readyVideo: RETRO_SCREEN2_VIDEO,
    hostGameVideo: RETRO_SCREEN3_VIDEO,
    buttons: {
      primary: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/6cyq8mto_YEST%20BUTTON%20HIPROCK%20STYL.png",
      challenge: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/cht9gdio_CHALLENGE%20BUTTON%20HIPPY.png",
      idk: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/u24zpg3c_NO%20BUTTON%20HIPROCK%20STYL.png",
    },
    host: { lobby: HOST_IMG, game: HOST_IMG, reveal: HOST_IMG },
    player: { join: PLAYER_IMG, game: PLAYER_IMG, reveal: PLAYER_IMG },
    thumb: RETRO_LANDING_IMG,
  },
  {
    id: "rock_roll",
    name: "Rock & Roll",
    icon: "Guitar",
    accent: "#c9962f",
    available: true,
    landing: { type: "video", url: ROCK_GOTHIC_VIDEO, poster: RETRO_LANDING_IMG },
    joinVideo: ROCK_GOTHIC_VIDEO,
    lobbyVideo: ROCK_LOBBY_VIDEO,
    playVideo: ROCK_OLDWOMAN_VIDEO,
    hostGameVideo: ROCK_HOST_VIDEO,
    hostRevealVideo: ROCK_HOST_VIDEO,
    hostFinishedVideo: ROCK_HOST_GAMEOVER_VIDEO,
    revealVideo: ROCK_LOBBY_VIDEO,
    buttons: {
      primary: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/09lcu0z3_ROCKGOTHiC%20YES.webp",
      challenge: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/8za74bz4_CHALLENGE%20BUTTON%20ROCK%20GOTH.png",
      idk: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/tr8ig2qa_NO%20BUTTON%20ROCK%20GOTHIC.webp",
    },
    buttonSplatter: "/rock-splatter.png",
    host: { lobby: HOST_IMG, game: HOST_IMG, reveal: HOST_IMG },
    player: { join: PLAYER_IMG, game: PLAYER_IMG, reveal: PLAYER_IMG },
    thumb: RETRO_LANDING_IMG,
  },
  {
    id: "puppy_love",
    name: "Bling & Flava",
    icon: "Gem",
    accent: "#C7CCD4",
    available: true,
    landing: { type: "video", url: BLING_FLAVA3_VIDEO, poster: RETRO_LANDING_IMG },
    lobbyVideo: BLING_FLAVA_VIDEO,
    joinVideo: BLING_FLAVA_VIDEO,
    getReadyVideo: BLING_FLAVA2_VIDEO,
    playVideo: BLING_FLAVA3_VIDEO,
    revealVideo: BLING_FLAVA3_VIDEO,
    hostGameVideo: BLING_FLAVA3_VIDEO,
    hostRevealVideo: BLING_FLAVA3_VIDEO,
    hostFinishedVideo: BLING_FLAVA3_VIDEO,
    host: { lobby: HOST_IMG, game: HOST_IMG, reveal: HOST_IMG },
    player: { join: PLAYER_IMG, game: PLAYER_IMG, reveal: PLAYER_IMG },
    thumb: RETRO_LANDING_IMG,
  },
  {
    id: "disco_modern",
    name: "Disco & Modern",
    icon: "Sparkles",
    accent: "#7c5cff",
    available: false,
    landing: { type: "image", url: RETRO_LANDING_IMG },
    host: { lobby: HOST_IMG, game: HOST_IMG, reveal: HOST_IMG },
    player: { join: PLAYER_IMG, game: PLAYER_IMG, reveal: PLAYER_IMG },
    thumb: RETRO_LANDING_IMG,
  },
];

export const DEFAULT_STYLE = "hip_retro";

export const getTheme = (id) => THEMES.find((t) => t.id === id) || THEMES[0];

export const getStoredStyle = () => {
  try { return localStorage.getItem("hm_style") || DEFAULT_STYLE; } catch { return DEFAULT_STYLE; }
};

export const setStoredStyle = (id) => {
  try { localStorage.setItem("hm_style", id); } catch {}
};

// Inline background-image style for a themed screen root.
export const bgImageStyle = (url) => ({
  backgroundImage: `url("${url}")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});
